import PropTypes from "prop-types";
import React from "react";

export default function Label(props) {
  // Check if the label ends with an asterisk and wrap it in a span
  const processChildren = (children) => {
    // Handle array of children (e.g., [translatedText, "*"])
    if (Array.isArray(children)) {
      return React.Children.map(children, (child) => {
        if (child === "*") {
          return <span className="required-asterisk">*</span>;
        }
        return child;
      });
    }

    // Handle single string with asterisk at the end
    if (typeof children === "string" && children.endsWith("*")) {
      const textWithoutAsterisk = children.slice(0, -1);
      return (
        <>
          {textWithoutAsterisk}
          <span className="required-asterisk">*</span>
        </>
      );
    }

    return children;
  };

  return <label>{processChildren(props.children)}</label>;
}

Label.propTypes = {
  children: PropTypes.any,
};
